import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CaseStudySection from '../components/CaseStudySection';

const WorkPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <CaseStudySection />
      </main>
      <Footer />
    </div>
  );
};

export default WorkPage;
